// Analytics
analytics.eventConfig.push(
    {

        "target": "*",
        "codeId": "lclsd",
        "events": [
            {
                "eventTarget": ".find-station-link-new",
                "eventType": "click",
                "tags": {
                    "event": "locator",
                    "componentId": "lfssd",
                    "componentName": "locator find station station details",
                    "eventType": "find station internal navigation click",
                    "elementType": "find station button",
                    "elementText": "",
                    "destinationUrl": "",
                    "searchType": "retailgasstations",
                    "titleText": ""
            }
        }]
    },
)